import script from "./SwitchTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwitchTag.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__